module.exports = __webpack_public_path__ + "img/live-started.7399508e.svg";